import { render } from "./App.vue?vue&type=template&id=13caea76&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=13caea76&scoped=true&lang=css"

import exportComponent from "/home/blueflamehaze/Documents/Projects/certificates/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13caea76"]])

export default __exports__